<!-- The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work. -->
<template>
  <div>
    <!-- 导航栏 style="border-bottom: 1px solid white;"-->
    <nav
      class="fixed top-0 left-0 w-full bg-black z-50 transition-all duration-300 h-20" 
    >
      <div class="container mx-auto px-6">
        <!-- justify-between 两端对齐 -->
        <!-- space-x-8 控制flex间距，导致ml-auto失效,如果要实现中文右对齐，其他左对齐,删除spcae-x-8即可,同时中文div改为ml-auto -->
        <div
          class="flex items-center space-x-8 h-20 border-gray-100"
        >
          <div class="flex items-center mx-auto md:mx-0 pl-10 md:pl-0">
            <img
              src="../../assets/logo.png"
              alt="Logo"
              class="mr-1 h-6 mt-[5px]"
              :style="{
                width: 'auto',
                height: '40px',
                transform: 'translateY(-3px)',
              }"
            />
            <h1 class="text-2xl md:text-3xl text-white">
              <router-link to="/" @click="toggleNav('')">
                <!-- 北境骑团 -->
                {{$t('company.name')}}
              </router-link>
            </h1>
          </div>
          <div class="hidden md:flex items-center space-x-1 text-white ">
            <!-- <div class="relative group">
              <button 
                class="py-[22px] text-white transition-colors duration-300 cursor-pointer whitespace-nowrap !rounded-button inline-block hover:underline underline-offset-[5px]"
                :class="{ 'text-white': activeNav === 'bike' }"
                @click="toggleNav('bike')"
                ref="menuRefBike"
              >
                自行车
                {{$t('header.bike')}}
              </button>
              <i
                :class="[
                  'fas',
                  activeNav === 'bike' ? 'fa-chevron-up' : 'fa-chevron-down','ml-1 text-xs'
                ]"
              ></i>
            </div> -->
            <!-- <div class="relative group">
              <button 
                class="py-[22px] pl-8 text-white transition-colors duration-300 cursor-pointer whitespace-nowrap !rounded-button inline-block hover:underline underline-offset-[5px]"
                :class="{ 'text-white': activeNav === 'accessory' }"
                @click="toggleNav('accessory')"
                ref="menuRefAccessory"
              >
                车配件
                {{$t('header.accessory')}}
              </button>
              <i
                :class="[
                  'fas',
                  activeNav === 'accessory' ? 'fa-chevron-up' : 'fa-chevron-down','ml-1 text-xs'
                ]"
              ></i>
            </div>
            <div class="relative group">
              <button 
                class="py-[22px] pl-8 text-white transition-colors duration-300 cursor-pointer whitespace-nowrap !rounded-button inline-block hover:underline underline-offset-[5px]"
                :class="{ 'text-white': activeNav === 'apparel' }"
                @click="toggleNav('apparel')"
                ref="menuRefApparel"
              >
                服装/更多
                {{$t('header.apparel')}}
              </button>
              <i
                :class="[
                  'fas',
                  activeNav === 'apparel' ? 'fa-chevron-up' : 'fa-chevron-down','ml-1 text-xs'
                ]"
              ></i>
            </div> -->
            <div class="relative group">
              <router-link :to="{ path: '/product', query: { type: 'bikeormore' } }" class="py-[22px] pl-8 text-white transition-colors duration-300 cursor-pointer whitespace-nowrap !rounded-button inline-block hover:underline underline-offset-[5px]">
                <!-- 自行车/更多 -->
                {{$t('header.bike_or_more')}}
                <!-- <i class="fas fa-chevron-down ml-1 text-xs"></i> -->
              </router-link>
            </div>
            <div class="relative group">
              <router-link :to="{ path: '/product', query: { type: 'sale' } }" class="py-[22px] pl-8 text-white transition-colors duration-300 cursor-pointer whitespace-nowrap !rounded-button inline-block hover:underline underline-offset-[5px]">
                <!-- 促销 -->
                {{$t('header.sale')}}
                <!-- <i class="fas fa-chevron-down ml-1 text-xs"></i> -->
              </router-link>
            </div>
            <div class="relative group">
              <router-link to="/newsPressReleases" class="py-[22px] pl-8 text-white transition-colors duration-300 cursor-pointer whitespace-nowrap !rounded-button inline-block hover:underline underline-offset-[5px]">
                <!-- 新闻资讯 -->
                {{$t('header.news_press_releases')}}
              </router-link>
            </div>
            <div class="relative group">
              <button 
                class="py-[22px] pl-8 text-white transition-colors duration-300 cursor-pointer whitespace-nowrap !rounded-button inline-block hover:underline underline-offset-[5px]"
                :class="{ 'text-white': activeNav === 'about' }"
                @click="toggleNav('about')"
                ref="menuRefAbout"
              >
                <!-- 关于我们 -->
                {{$t('header.about')}}
              </button>
              <i
                :class="[
                  'fas',
                  activeNav === 'about' ? 'fa-chevron-up' : 'fa-chevron-down','ml-1 text-xs'
                ]"
              ></i>
            </div>
            
 
            <!-- 切换中英文 -->
            <a  class="py-[22px] pl-8 text-white transition-colors duration-300 cursor-pointer whitespace-nowrap !rounded-button inline-block hover:underline underline-offset-[5px]" @click="changeLanguage()" >{{ $t('language.code') }} | {{ $t('language.title') }}</a>
          </div>
          <!-- <div class="hidden md:flex items-center space-x-1 text-white ml-auto">
            切换中英文
            <a  class="py-[22px] pl-8 text-white transition-colors duration-300 cursor-pointer whitespace-nowrap !rounded-button inline-block hover:underline underline-offset-[5px]" @click="changeLanguage()" >{{ $t('language.code') }} | {{ $t('language.title') }}</a>
          </div> -->
          <div class="md:hidden">
            <!-- hover:bg-gray-100 -->
            <button
              @click="toggleMobileMenu"
              class="p-2 text-gray-700 hover:text-gray-900  rounded-md transition-all duration-200 !rounded-button whitespace-nowrap"
            >
              <i class="fas fa-bars text-xl text-white"></i>
            </button>
          </div>
        </div>
      </div>
    </nav>
    <!-- 自行车二级菜单 -->
    <div 
      v-if="activeNav === 'bike'" 
      class="fixed left-0 w-full bg-black z-50 transition-all duration-300">
      <div class="container mx-auto px-6 py-6">
        <div class="hidden md:flex space-x-1 text-white text-left">
          <div class="relative group">
            <router-link to="/roadBike" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 公路自行车 -->
              {{$t('header.road_bike')}}
            </router-link>
            <!-- <router-link :to="{ path: '/bike', hash: '#contact' }" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              {{$t('company.homePage_ex_contact')}}
            </router-link> -->
          </div>
          <div class="relative group pl-48">
            <router-link to="/mountainBike" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 山地自行车 -->
              {{$t('header.mountain_bike')}}
            </router-link>
          </div>
          <div class="relative group pl-48">
            <router-link to="/foldingBike" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 折叠自行车 -->
              {{$t('header.folding_bike')}}
            </router-link>
          </div>
          <div class="relative group pl-48">
            <router-link to="/kidsBike" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 儿童自行车 -->
              {{$t('header.kids_bike')}}
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- 车配件二级菜单 -->
    <div 
      v-if="activeNav === 'accessory'" 
      class="fixed left-0 w-full bg-black z-50 transition-all duration-300">
      <div class="container mx-auto px-6 py-6">
        <div class="hidden md:flex space-x-1 text-white text-left">
          <div class="relative group">
            <router-link to="/handlebar" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 车把 -->
              {{$t('header.handlebar')}}
            </router-link>
            <router-link to="/carBell" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 车铃 -->
              {{$t('header.car_bell')}}
            </router-link>
            <router-link to="/carLock" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 车锁 -->
              {{$t('header.car_lock')}}
            </router-link>
          </div>
          <div class="relative group pl-48">
            <router-link to="/brake" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 刹车 -->
              {{$t('header.brake')}}
            </router-link>
            <router-link to="/variableSpeed" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 变速 -->
              {{$t('header.variable_speed')}}
            </router-link>
          </div>
          <div class="relative group pl-48">
            <router-link to="/crank" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 曲柄 -->
              {{$t('header.crank')}}
            </router-link>
            <router-link to="/chain" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 链条 -->
              {{$t('header.chain')}}
            </router-link>
            <router-link to="/pedal" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 脚踏 -->
              {{$t('header.pedal')}}
            </router-link>
          </div>
          <div class="relative group pl-48">
            <router-link to="/seat" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 车座 -->
              {{$t('header.seat')}}
            </router-link>
            <router-link to="/seatPost" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 座杆 -->
              {{$t('header.seat_post')}}
            </router-link>
          </div>
          <div class="relative group pl-48">
            <router-link to="/wheels" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 轮胎 -->
              {{$t('header.wheels')}}
            </router-link>
            <router-link to="/wheelSet" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 轮组 -->
              {{$t('header.wheel_set')}}
            </router-link>
            <router-link to="/stickers" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 贴纸 -->
              {{$t('header.stickers')}}
            </router-link>
            <router-link to="/bicyclePump" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 打气筒 -->
              {{$t('header.bicycle_pump')}}
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- 服装/更多二级菜单 -->
    <div 
      v-if="activeNav === 'apparel'" 
      class="fixed left-0 w-full bg-black z-50 transition-all duration-300">
      <div class="container mx-auto px-6 py-6">
        <div class="hidden md:flex space-x-1 text-white text-left">
          <div class="relative group">
            <router-link to="/helmets" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 头盔 -->
              {{$t('header.helmets')}}
            </router-link>
            <router-link to="/shoes" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 鞋子 -->
              {{$t('header.shoes')}}
            </router-link>
            <router-link to="/clothing" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 骑行服 -->
              {{$t('header.clothing')}}
            </router-link>
          </div>
          <div class="relative group pl-48">
            <router-link to="/other" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 其它 -->
              {{$t('header.other')}}
            </router-link>
          </div>
          
        </div>
      </div>
    </div>

    <!-- 关于我们二级菜单 -->
    <div 
      v-if="activeNav === 'about'" 
      class="fixed left-0 w-full bg-black z-40 transition-all duration-300 position pt-20">
      <div class="container mx-auto px-6 py-6">
        <div class="hidden md:flex space-x-1 text-white text-left">
          <div class="relative group">
            <router-link to="/cultureAndValues" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 文化和价值观 -->
              {{$t('header.culture_and_values')}}
            </router-link>
            <router-link :to="{ path: '/cultureAndValues', hash: '#milestone' }" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 里程碑 -->
              {{$t('header.milestone')}}
            </router-link>
            <router-link :to="{ path: '/cultureAndValues', hash: '#leadershipTeam' }" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 领导团队 -->
              {{$t('header.leadership_team')}}
            </router-link>
            <router-link to="/ourBusiness" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              <!-- 我们的业务 -->
              {{$t('header.our_business')}}
            </router-link>
          </div>
          <div class="relative group pl-48">
            <!-- <router-link to="/securityCheck" class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]">
              防伪查询
              {{$t('header.security_check')}}
            </router-link> -->
            <router-link
              to="/securityCheck"
              class="md:flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
            >
              <!-- 防伪查询 -->
              {{$t('header.security_check')}}
            </router-link>
          </div>
          
        </div>
      </div>
    </div>

    <!-- 移动端菜单 -->
    <div
      v-if="mobileMenuOpen"
      class="fixed inset-0 bg-black z-40 md:hidden overflow-y-auto"
    >
      <div class="pt-10 pb-4 px-6 border-b border-gray-100">
        <!-- <div class="flex items-center justify-between">
          <h1 class="text-2xl font-bold text-gray-900">北境骑团</h1>
          <button
            @click="toggleMobileMenu"
            class="p-2 text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-md transition-all duration-200 !rounded-button whitespace-nowrap"
          >
            <i class="fas fa-times text-xl"></i>
          </button>
        </div> -->
      </div>
      <div class="px-6 py-4">
        <div class="flex flex-col space-y-2">
          <div class="space-y-2">
            <button
              class="w-full flex items-center justify-between px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md text-left"
              @click="navigateTo('/')"
            >
              <!-- 首页 -->
              {{$t('header.homePage')}}
            </button>
          </div>
          <div class="space-y-2">
            <button
              class="w-full flex items-center justify-between px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md text-left"
              @click="navigateTo('/product', { type: 'bikeormore' })"
            >
              <!-- 自行车/更多 -->
              {{$t('header.bike_or_more')}}
            </button>
          </div>
          <div class="space-y-2">
            <button
              class="w-full flex items-center justify-between px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md text-left"
              @click="navigateTo('/product', { type: 'sale' })"
            >
              <!-- 促销 -->
              {{$t('header.sale')}}
            </button>
          </div>
          <div class="space-y-2">
            <button
              class="w-full flex items-center justify-between px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md text-left"
              @click="navigateTo('/newsPressReleases')"
            >
              <!-- 新闻资讯 -->
              {{$t('header.news_press_releases')}}
            </button>
          </div>
          <!-- <div class="space-y-2">

            <div
              class="flex items-center justify-between px-4 py-2 text-white hover:text-white hover:bg-black rounded-md cursor-pointer"
              @click="toggleSubmenu('bike')"
            >
              <span>
                自行车
                {{$t('header.bike')}}
              </span>
              <i
                :class="[
                  'fas',
                  submenuOpen.bike ? 'fa-chevron-up' : 'fa-chevron-down',
                ]"
              ></i>
            </div>
            <div v-if="submenuOpen.bike" class="pl-6 space-y-2">
              <router-link to="/" @click="toggleMobileMenu"
                        class="block px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md">
                  公路自行车
                  {{$t('header.road_bike')}}
              </router-link>
              <router-link :to="{ path: '/', hash: '#equipment' }" @click="toggleMobileMenu"
                        class="block px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md">
                  山地自行车
                  {{$t('header.mountain_bike')}}
              </router-link>
              <router-link :to="{ path: '/', hash: '#routes' }" @click="toggleMobileMenu"
                        class="block px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md">
                  折叠自行车
                  {{$t('header.folding_bike')}}
              </router-link>
              <router-link :to="{ path: '/', hash: '#community' }" @click="toggleMobileMenu"
                        class="block px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md">
                  儿童自行车
                  {{$t('header.kids_bike')}}
              </router-link>
            </div>
          </div> -->
          <!-- <div class="space-y-2">

            <div
              class="flex items-center justify-between px-4 py-2 text-white hover:text-white hover:bg-black rounded-md cursor-pointer"
              @click="toggleSubmenu('accessory')"
            >
              <span>
                车配件
                {{$t('header.accessory')}}
              </span>
              <i
                :class="[
                  'fas',
                  submenuOpen.accessory ? 'fa-chevron-up' : 'fa-chevron-down',
                ]"
              ></i>
            </div>
            <div v-if="submenuOpen.accessory" class="pl-6 space-y-2">
              <router-link to="/" @click="toggleMobileMenu"
                        class="block px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md">
                  车把
                  {{$t('header.handlebar')}}
              </router-link>
              <router-link :to="{ path: '/', hash: '#equipment' }" @click="toggleMobileMenu"
                        class="block px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md">
                  车铃
                  {{$t('header.car_bell')}}
              </router-link>
            </div>
          </div> -->
          <div class="space-y-2">

            <div
              class="flex items-center justify-between px-4 py-2 text-white hover:text-white hover:bg-black rounded-md cursor-pointer"
              @click="toggleSubmenu('about')"
            >
              <span>
                <!-- 关于我们 -->
                {{$t('header.about')}}
              </span>
              <i
                :class="[
                  'fas',
                  submenuOpen.about ? 'fa-chevron-up' : 'fa-chevron-down',
                ]"
              ></i>
            </div>
            <div v-if="submenuOpen.about" class="pl-6 space-y-2">
              <button
                class="w-full block px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md text-left"
                @click="navigateTo('/cultureAndValues')"
              >
                <!-- 文化和价值观 -->
                {{$t('header.culture_and_values')}}
              </button>
              <button
                class="w-full block px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md text-left"
                @click="navigateTo('/cultureAndValues')"
              >
                <!-- 里程碑 -->
                {{$t('header.milestone')}}
              </button>
              <button
                class="w-full block px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md text-left"
                @click="navigateTo('/cultureAndValues')"
              >
                <!-- 领导团队 -->
                {{$t('header.leadership_team')}}
              </button>
              <button
                class="w-full block px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md text-left"
                @click="navigateTo('/ourBusiness')"
              >
                <!-- 我们的业务 -->
                {{$t('header.our_business')}}
              </button>
              <button
                class="w-full block px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md text-left"
                @click="navigateTo('/securityCheck')"
              >
                <!-- 防伪查询 -->
                {{$t('header.security_check')}}
              </button>
              <!-- <a
                href="http://chaxun.hzcg315.com/wscan.aspx?u=4304"
                @click="toggleMobileMenu"
                class="flex items-center justify-between px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md cursor-pointer"
                >
                防伪查询
                {{$t('company.security_check')}}
                </a> -->
            </div>
          </div>


          <!-- 下变的a标签 #contact 原来居中样式 class="px-4 py-2 text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-md transition-all duration-200" -->
          
          <!-- <a
            href="http://chaxun.hzcg315.com/wscan.aspx?u=4304"
            @click="toggleMobileMenu"
            class="flex items-center justify-between px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md cursor-pointer"
            >
            防伪查询
            {{$t('company.securityCheck')}}
            </a> -->
          <!-- <button
            class="mt-4 w-full px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-all duration-200 !rounded-button whitespace-nowrap"
          >
            立即加入
          </button> -->
          <!-- 切换中英文 -->
          <a  class="flex items-center justify-between px-4 py-2 text-white hover:text-gray-900 hover:bg-gray-100 rounded-md cursor-pointer" @click="changeLanguage('close')" >{{ $t('language.code') }} | {{ $t('language.title') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted, onBeforeUnmount } from "vue";
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

// 配置语言环境
const { locale } = useI18n()
const router = useRouter()

const navigateTo = (path: string, query?: Record<string, string>) => {
  toggleMobileMenu()
  if (query) {
    router.push({ path, query })
  } else {
    router.push(path)
  }
}

// 切换中英文
const changeLanguage = (code: string) => {
  if (locale.value === 'zh') {
    locale.value = 'en'
    localStorage.setItem('lang', 'en')// 持久化，避免刷新页面后重置中英文
  } else {
    locale.value = 'zh'
    localStorage.setItem('lang', 'zh')// 持久化，避免刷新页面后重置中英文
  }
  
  // 手机端切换语言后关闭下拉框
  if(code === 'close'){
    toggleMobileMenu()
  }
}

// 三横线的显示与隐藏
const mobileMenuOpen = ref(false);
// 控制移动端导航菜单中各子菜单的显示与隐藏
const submenuOpen = ref({
  bike: false,
  accessory: false,
  equipment: false,
  community:false,
  about: false,
});
// 切换移动端导航菜单的显示与隐藏状态
const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value;
  if (!mobileMenuOpen.value) {
    Object.keys(submenuOpen.value).forEach((key) => {
      submenuOpen.value[key] = false;
    });
  }
};
// 控制移动端菜单中的子菜单显示与隐藏，改变值函数
const toggleSubmenu = (menu: string) => {
  submenuOpen.value[menu] = !submenuOpen.value[menu];
};

// 二级菜单数据
const activeNav = ref('');
const toggleNav = (navName: string) => {
  if (activeNav.value === navName) {
    activeNav.value = '';
  } else {
    activeNav.value = navName;
  }
};

// 点击文档其他位置关闭下拉菜单
const menuRefBike = ref(null)
const menuRefAccessory = ref(null)
const menuRefApparel = ref(null)
const menuRefAbout = ref(null)
const handleClickOutside = (event) => {
  //  console.log(event.target)
  // console.log(menuRef.value)
  // if (menuRef.value && !menuRef.value.contains(event.target)) {
  //   activeNav.value = '';
  // }
  // const clickedOutside = [menuRefBike, menuRefAccessory, menuRefApparel, menuRefAbout].every(
  const clickedOutside = [menuRefAbout].every(
    ref => ref.value && !ref.value.contains(event.target)
  )
  // console.log(clickedOutside)
  // console.log(activeNav.value)
  if (clickedOutside) {
    activeNav.value = '';
  }
}

onMounted(() => {
  // 这段代码的主要功能是根据用户在页面上的滚动位置动态地为导航栏添加或移除阴影效果。具体来说，当页面的垂直滚动距离大于 100 像素时，导航栏会显示一个中等大小的阴影，使其在页面滚动时更加突出，提升用户体验。当滚动距离小于或等于 100 像素时，阴影效果会被移除，从而使页面顶部看起来更加简洁。
  window.addEventListener("scroll", () => {
    const nav = document.querySelector("nav");
    if (window.scrollY > 100) {
      nav?.classList.add("shadow-md");
    } else {
      nav?.classList.remove("shadow-md");
    }
  });
  // 点击文档其他位置关闭下拉菜单 ，使用addEventListener监听点击事件
  document.addEventListener('click', handleClickOutside)
  
});
onBeforeUnmount(() => {
  // 移除监听事件
  document.removeEventListener('click', handleClickOutside)
})
</script>

<style scoped>

.mask {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;

}

</style>
